import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import Styles from './LeadCaptureForm.css'
import {
  Link
} from '../../components'

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mqenepal'

const PURPOSE_OPTIONS = [
  { value: 'for-profit',  label: 'For-profit' },
  { value: 'individual',  label: 'Individual investor' },
  { value: 'non-profit',  label: 'Non-profit / academic' },
  { value: 'other',  label: 'Other (describe below)' },
]

@CSSModules(Styles, { allowMultiple: true })
class LeadCaptureForm extends Component {
  static propTypes = {
    onDismiss: PropTypes.func,
    cycle: PropTypes.int,
  }

  static defaultProps = {
    onDismiss: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      firstName:   '',
      lastName:    '',
      email:       '',
      org:         '',
      purpose:     null,
      description: '',
      // consent screen
      screen:      'form',   // 'form' | 'submitted'
      acceptTerms: false,
      emailSignup: true,
      // async state
      submitting: false,
      errors: {},
    }
    this.handleSubmit        = this.handleSubmit.bind(this)
    this.handleClose         = this.handleClose.bind(this)
    this.handleOverlayClick  = this.handleOverlayClick.bind(this)
    this.handlePurposeSelect = this.handlePurposeSelect.bind(this)
    this.goBack              = this.goBack.bind(this)
  }

  setFullYearCookie() {
    const expires = new Date()
    expires.setFullYear(expires.getFullYear() + 1)
    document.cookie = `ayk_iyv_lead_form_submitted=true; expires=${expires.toUTCString()}; path=/`
  }

  validate() {
    const { firstName, lastName, email, org, purpose, acceptTerms } = this.state
    const errors = {}
    if (!firstName.trim())  errors.firstName = 'Required'
    if (!lastName.trim())   errors.lastName  = 'Required'
    if (!email.trim())      errors.email     = 'Required'
    if (!acceptTerms)       errors.consent   = 'Required'
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = 'Invalid email'
    if (!purpose)           errors.purpose   = 'Please select a purpose'
    return errors
  }

  handlePurposeSelect(value) {
    this.setState({ purpose: value, errors: Object.assign({}, this.state.errors, { purpose: null }) })
  }

  handleSubmit(e) {
    e.preventDefault()
    const errors = this.validate()
    if (Object.keys(errors).length > 0) {
      this.setState({ errors })
      return
    }
    this.doSubmit()
  }

  doSubmit() {
    this.setState({ submitting: true, errors: {} })
    const { firstName, lastName, email, purpose, description, emailSignup } = this.state
    fetch(FORMSPREE_ENDPOINT, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ firstName, lastName, email, purpose, description, emailSignup, site: config.app.title }),
    })
      .then(() => {
        this.setFullYearCookie()
        this.setState({ screen: 'submitted', submitting: false })
      })
      .catch(() => {
        this.setState({
          submitting: false,
          errors: { form: 'Something went wrong. Please try again.' },
        })
      })
  }

  handleClose() {
    this.props.onDismiss()
  }

  handleOverlayClick(e) {
    if (e.target === e.currentTarget) {
      this.handleClose()
    }
  }

  goBack() {
    this.setState({ screen: 'form', errors: {} })
  }

  renderField({ id, label, type = 'text', value, onChange, error, placeholder }) {
    return (
      <div styleName={`form__field${error ? ' form__field--error' : ''}`} key={id}>
        <label styleName="form__label" htmlFor={id}>
          {label}
          <span styleName="form__required">*</span>
        </label>
        <input
          styleName={`form__input${error ? ' form__input--error' : ''}`}
          id={id}
          name={id}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder || ''}
          autoComplete="off"
        />
        {error && <span styleName="form__error-msg">{error}</span>}
      </div>
    )
  }

  renderForm() {
    const { firstName, lastName, email, purpose, description, submitting, errors } = this.state

    return (
      <div styleName="modal__body">
        <div styleName="modal__header">
          <h2 styleName="modal__title">Help us understand our impact</h2>
          <p styleName="modal__subtitle">
            Our data is free and open for individual investors, researchers,
            and non-profits.
            {
              this.props.cycle > 1 ?
                <span>
                  <br/>
                  <b>Tired of seeing this?</b> We won't show this again if you fill it out.
                </span> :
                null
            }
          </p>
        </div>

        <form styleName="form" onSubmit={this.handleSubmit} noValidate>
          <div styleName="form__row">
            {this.renderField({
              id:          'firstName',
              label:       'First name',
              placeholder: 'Jane',
              value:       firstName,
              onChange:    e => this.setState({ firstName: e.target.value }),
              error:       errors.firstName,
            })}
            {this.renderField({
              id:          'lastName',
              label:       'Last name',
              placeholder: 'Smith',
              value:       lastName,
              onChange:    e => this.setState({ lastName: e.target.value }),
              error:       errors.lastName,
            })}
          </div>

          {this.renderField({
            id:          'email',
            label:       'Email',
            type:        'email',
            placeholder: 'jane@organization.org',
            value:       email,
            onChange:    e => this.setState({ email: e.target.value }),
            error:       errors.email,
          })}

          <div styleName={`form__field${errors.purpose ? ' form__field--error' : ''}`}>
            <span styleName="form__label">
              Purpose of use
              <span styleName="form__required">*</span>
            </span>
            <div styleName="purpose-grid">
              {PURPOSE_OPTIONS.map(opt => (
                <div
                  key={opt.value}
                  styleName={`purpose-option${purpose === opt.value ? ' purpose-option--selected' : ''}`}
                  onClick={() => this.handlePurposeSelect(opt.value)}
                >
                  <span styleName={`purpose-dot${purpose === opt.value ? ' purpose-dot--selected' : ''}`} />
                  {opt.label}
                </div>
              ))}
            </div>
            {errors.purpose && <span styleName="form__error-msg">{errors.purpose}</span>}
          </div>

          <div styleName="form__field">
            <label styleName="form__label" htmlFor="description">
              Brief description of use
            </label>
            <textarea
              styleName="form__textarea"
              id="description"
              placeholder="How do you use Invest Your Values?"
              value={description}
              onChange={e => this.setState({ description: e.target.value })}
            />
          </div>

          <label styleName="consent-row">
            <input
              styleName="consent-checkbox"
              type="checkbox"
              checked={this.state.acceptTerms}
              onChange={e => this.setState({ acceptTerms: e.target.checked })}
            />
            <span styleName="consent-row__text">I agree not to resell, redistribute, or use this data for commercial purposes without prior written consent.</span>
          </label>
          {errors.consent && <span styleName="form__error-msg">{errors.consent}</span>}

          <label styleName="consent-row">
            <input
              styleName="consent-checkbox"
              type="checkbox"
              checked={this.state.emailSignup}
              onChange={e => this.setState({ emailSignup: e.target.checked })}
            />
            <span styleName="consent-row__text">I'd like to be added to As You Sow's monthly email updates list. (We will never share your information. You can update or unsubscribe using the link at the bottom of our emails. See our <Link xstrong to={config.routes.legal} targetBlank title='Privacy policy'>privacy policy</Link>.)</span>
          </label>

          {errors.form && <div styleName="form__global-error">{errors.form}</div>}

          <button
            styleName={`form__submit${submitting ? ' form__submit--loading' : ''}`}
            type="submit"
            disabled={submitting}
          >
            {submitting ? <span styleName="form__spinner" /> : 'Submit'}
          </button>
        </form>
      </div>
    )
  }

  renderThankYou() {
    return (
      <div styleName="modal__body modal__body--thankyou">
        <div styleName="thankyou">
          <div styleName="thankyou__icon">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2.5" />
              <path d="M14 25l7 7 13-14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h2 styleName="thankyou__title">Thank you!</h2>
          <p styleName="thankyou__message">
            Knowing who uses our data helps us do our work better. If you selected
            "for-profit", someone from our team will be in touch
            about a licensing arrangement. In the meantime, feel free to
            explore the platform.
          </p>
          <button styleName="thankyou__cta" onClick={this.handleClose}>
            Continue
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { screen } = this.state
    const isSubmitted = screen === 'submitted'

    return (
      <div styleName="overlay" onClick={this.handleOverlayClick} role="dialog" aria-modal="true">
        <div styleName={`modal${isSubmitted ? ' modal--thankyou' : ''}`}>
          <button styleName="modal__close" onClick={this.handleClose} aria-label="Close">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
          {screen === 'form'      && this.renderForm()}
          {screen === 'submitted' && this.renderThankYou()}
        </div>
      </div>
    )
  }
}

export default LeadCaptureForm